import { WHY_WE_RENT } from 'shared/constants/whyWeRent';
import { Title } from '../Title';
import * as style from './WhyWeRent.css';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

export const WhyWeRent: React.FC = () => {
  const device = useDeviceType();

  return (
    <div
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['title']}>
        <Title>Почему мы&nbsp;сдадим вашу квартиру в&nbsp;2&nbsp;раза быстрее</Title>
      </div>
      <div className={style['list']}>
        {WHY_WE_RENT.map((item, index) => (
          <div key={index} className={style['item']}>
            <div className={style['text-block']}>
              <div className={style['item-title']}>{item.title}</div>
              <div className={style['description']}>{item.description}</div>
            </div>
            <div className={clsx(style['image'], style[item.imgClass])} />
          </div>
        ))}
      </div>
    </div>
  );
};
